import { render, staticRenderFns } from "./AsideBarRisks.vue?vue&type=template&id=79bcf12a&scoped=true"
import script from "./AsideBarRisks.vue?vue&type=script&lang=js"
export * from "./AsideBarRisks.vue?vue&type=script&lang=js"
import style0 from "./AsideBarRisks.vue?vue&type=style&index=0&id=79bcf12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bcf12a",
  null
  
)

export default component.exports